module.exports = __webpack_public_path__ + "static/media/world-map.75ac80f6.jpg";